// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1MzaE","dragIcon":"Choice_dragIcon__2hYUr","left":"Choice_left__1DsCf","input":"Choice_input__5TDAU"};